import jwtDecode from "jwt-decode";
import keycloak from "../Keycloak";
import { CARD_URL } from "./BackendInterface";
import { toast } from "react-toastify";
import i18n from "../i18n/i18n";
import { Subject } from "rxjs";

// string constants
const JURA_HQ_CARD_LABEL = "Mitarbeiterpass";
const JURA_HQ_CARD_NOTICE =
  "Dieser Ausweis ist persönlich und nicht übertragbar. Der Mitarbeiterpass ist auf Verlangen vorzuweisen.";
const JURA_HQ_CARD_LABEL_PENSION = "Pensionärenpass";
const JURA_HQ_CARD_NOTICE_PENSION =
  "Dieser Ausweis ist persönlich und nicht übertragbar. Der Pensionärenpass ist auf Verlangen vorzuweisen.";

// disclaimer, not sure if this will ever get translated, so putting it here.....
export const disclaimerTitle =
  "Vielen Dank, dass Sie unsere NFC-Visitenkarte gescannt haben. Bitte beachten Sie die folgenden Hinweise:";
export const disclaimerBody = `
Durch das Scannen und Abspeichern der NFC-Visitenkarte auf Ihrem mobilen Gerät bestätigen Sie, dass Sie die von JURA Elektroapparate AG erhaltenen Geschäftskontaktdaten ausschliesslich für geschäftliche Zwecke bearbeiten. Die JURA Elektroapparate AG weist Sie darauf hin, dass die Weitergabe an Dritte oder die Veränderung der erhaltenen Geschäftskontaktdaten in jeglicher Form untersagt ist.
Falls Sie Fragen oder Bedenken bezüglich der Verwendung der erhaltenen Daten haben oder weitere Informationen benötigen, stehen wir Ihnen gerne zur Verfügung. Bitte kontaktieren Sie uns, um etwaige Anliegen zu klären.
`;

// rxjs stuff to be accessed from everywhere
export const sortSubject: Subject<SortInfo> = new Subject();

// enums and interfaces --------

export interface ListColumn {
  labelKey: string; // key, for translation
  hasSorting?: boolean;
  forceLabel?: string; // to not use translation and just force a string
}

export interface SortInfo {
  type: SortType;
  columnLabel: string;
}

export enum SortType {
  ALPHABET,
  ALPHABET_REVERSE,
  NONE,
}

// export enum DefaultLayout {
//   EMPLOYEE = "layout-0",
//   PENSIONER = "layout-1",
//   NONE = "none",
// }

// export const getAvailableLayouts = (area: DefaultArea): DefaultLayout[] => {
//   switch (area) {
//     case DefaultArea.JURA_HQ:
//     case DefaultArea.JURA_VERTRIEB_CH:
//       return [DefaultLayout.EMPLOYEE, DefaultLayout.PENSIONER];

//     default:
//       return [];
//   }
// };

// export const getLayoutEnumKeyString = (layout: DefaultLayout): string => {
//   const index = Object.values(DefaultLayout).findIndex((e) => e === layout);
//   if (index < 0) {
//     return "none";
//   }

//   return Object.keys(DefaultLayout)[index];
// };
// export const getLayoutNumFromEnum = (layout: DefaultLayout): number => {
//   const foundIndex = Object.values(DefaultLayout).findIndex((e) => e === layout);
//   return Math.max(0, foundIndex);
// };
// export const getLayoutEnumFromNum = (num: number | undefined): DefaultLayout => {
//   if (num === undefined) return DefaultLayout.NONE;

//   const res = Object.values(DefaultLayout).find((v) => {
//     const split = v.split("-");
//     if (split.length === 2 && split[1] === num.toString()) {
//       return true;
//     }
//     return false;
//   });

//   return res ?? DefaultLayout.EMPLOYEE;
// };

// export const getAddressFromDefaultArea = (area: DefaultArea, layout?: DefaultLayout): string => {
//   switch (area) {
//     case DefaultArea.JURA_HQ:
//       if (layout === undefined || layout === DefaultLayout.EMPLOYEE) {
//         return "JURA Elektroapparate AG, Kaffeeweltstrasse 10, 4626 Niederbuchsiten, Schweiz";
//       } else {
//         // layout === DefaultLayout.PENSION
//         return "JURA Elektroapparate AG, Kaffeeweltstrasse 10, 4626 Niederbuchsiten, Schweiz";
//       }

//     case DefaultArea.JURA_VERTRIEB_CH:
//       return "JURA Vertrieb (Schweiz) AG, Kaffeeweltstrasse 7, 4626 Niederbuchsiten, Schweiz";

//     default:
//       return "";
//   }
// };

/**
 * Generate hardcoded card labels based on the chosen area and layout
 * @param area
 * @param layout
 * @returns
 */
// export const getExtraCardPdfInfos = (
//   area: DefaultArea,
//   layout: DefaultLayout
// ): { cardLabel: string; cardNotice: string } => {
//   switch (area) {
//     case DefaultArea.JURA_HQ:
//       switch (layout) {
//         case DefaultLayout.EMPLOYEE:
//           return { cardLabel: JURA_HQ_CARD_LABEL, cardNotice: JURA_HQ_CARD_NOTICE };

//         case DefaultLayout.PENSIONER:
//           return { cardLabel: JURA_HQ_CARD_LABEL_PENSION, cardNotice: JURA_HQ_CARD_NOTICE_PENSION };

//         default:
//           return { cardLabel: JURA_HQ_CARD_LABEL, cardNotice: JURA_HQ_CARD_NOTICE };
//       }

//     case DefaultArea.JURA_VERTRIEB_CH:
//       switch (layout) {
//         case DefaultLayout.EMPLOYEE:
//           return { cardLabel: JURA_HQ_CARD_LABEL, cardNotice: JURA_HQ_CARD_NOTICE };

//         case DefaultLayout.PENSIONER:
//           return { cardLabel: JURA_HQ_CARD_LABEL_PENSION, cardNotice: JURA_HQ_CARD_NOTICE_PENSION };

//         default:
//           return { cardLabel: JURA_HQ_CARD_LABEL, cardNotice: JURA_HQ_CARD_NOTICE };
//       }

//     default:
//       return { cardLabel: JURA_HQ_CARD_LABEL, cardNotice: JURA_HQ_CARD_NOTICE };
//   }
// };

/**
 *
 * @returns Array of users / operators' names, for users the nfcId, prefixed with user_
 */
export const getSelectedUsers = (): string[] => {
  const selectedUsers: string[] = [];

  const theElems = document.querySelectorAll("[id*=checkbox_]");
  for (let i = 0; i < theElems.length; i++) {
    const elem = theElems[i];
    if ((elem as HTMLInputElement).checked) {
      selectedUsers.push(elem.id.split("checkbox_")[1]);
    }
  }
  return selectedUsers;
};

export const getEmailFromKeycloakSession = (): string => {
  const authToken = keycloak.token;
  if (!authToken) {
    return "";
  } else {
    let decodedTokenPayload;
    try {
      decodedTokenPayload = jwtDecode(authToken);
    } catch (e) {
      console.error("couldn't decode token for auth");
      return "";
    }

    if ((decodedTokenPayload as any)?.email) {
      return (decodedTokenPayload as any).email;
    } else return "";
  }
};

export const getNFCLink = (nfcId: string): string => {
  return `${CARD_URL}?id=${nfcId}`;
};

/**
 * Only support jpg and png
 * @param input
 * @returns
 */
export const getFileTypeFromName = (input: string): string => {
  let split: string[];
  if (input.toLowerCase().includes(".png")) {
    return "png";
  } else if (input.toLowerCase().includes(".jpg")) {
    return "jpg";
  } else return "";
};

export const showErrorNotification = (translatedTitle: string) => {
  toast.error(translatedTitle, {
    position: "top-right",
    autoClose: 30000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
export const showSuccessNotification = (translatedTitle: string) => {
  toast.success(translatedTitle, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
export const showInfoNotification = (translatedTitle: string) => {
  toast.info(translatedTitle, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
export const showPromiseNotification = (
  translatedTitlePending: string,
  translatedTitleSuccess: string,
  translatedTitleError: string
): Subject<boolean> => {
  const notificationSubject = new Subject<boolean>();
  const downloadPromise = new Promise((resolve, reject) => {
    const sub = notificationSubject.subscribe((succ) => {
      if (succ) {
        resolve(undefined);
        console.log("should have resolved");
      } else {
        reject(undefined);
      }
      sub.unsubscribe();
    });
  });

  toast.promise(downloadPromise, {
    pending: translatedTitlePending,
    success: translatedTitleSuccess,
    error: translatedTitleError,
  });

  return notificationSubject;
};

export const copyToClipboard = (text: string, notificationTitleKey?: string) => {
  navigator.clipboard.writeText(text);
  console.log("copied");
  showInfoNotification(
    notificationTitleKey ? i18n.t(notificationTitleKey) : i18n.t("info-copied-clipboard")
  );
};

export const setRowCheckboxState = (state: boolean) => {
  const theElems = document.querySelectorAll("[id*=checkbox_]");
  for (const checkBox of theElems) {
    (checkBox as HTMLInputElement).checked = state;
  }
};

export const listSort = (a: any, b: any, _currentSorting: SortInfo): number => {
  if (_currentSorting) {
    const valA = (a as any)[_currentSorting.columnLabel].toUpperCase();
    const valB = (b as any)[_currentSorting.columnLabel].toUpperCase();
    if (_currentSorting.type === SortType.ALPHABET) {
      const comparison = valA < valB ? -1 : valA > valB ? 1 : 0;
      console.log("valA:", valA, " valB:", valB, " comparison:", comparison);
      return comparison;
    } else if (_currentSorting.type === SortType.ALPHABET_REVERSE) {
      const comparison = valA > valB ? -1 : valA < valB ? 1 : 0;
      console.log("valA:", valA, " valB:", valB, " comparison:", comparison);
      return comparison;
    }
  }

  return 0;
};
